import React from 'react';
import { useTranslation } from 'react-i18next';
import Text from '../../containers/Text';
import './HomePage.scss';

const SocialSection = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer-container">
      <div className="footer-content">

        {/* Social Links Group */}
        <div className="social-links">
          <a
            href="https://www.instagram.com/yeuls.fincome/"
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon-wrapper"
            aria-label="Instagram"
          >
            <Text text={<i data-lucide="instagram" className="icon" />} />
          </a>
          <a
            href="https://www.linkedin.com/company/yeul-sachir/"
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon-wrapper"
            aria-label="LinkedIn"
          >
            <Text text={<i data-lucide="linkedin" className="icon" />} />
          </a>
          <a
            href="https://www.facebook.com/yemploy"
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon-wrapper"
            aria-label="Facebook"
          >
            <Text text={<i data-lucide="facebook" className="icon" />} />
          </a>
        </div>

        {/* Copyright Text */}
        <div className="copyright-text">
          <p><Text text={t('all-rights-reserved')} /></p>
        </div>

      </div>
    </footer>
  );
};

export default SocialSection;
